import "../../css/procedure.css";
import walk from "../../images/walk.gif";
import house_with_garden from "../../images/house-with-garden_svgrepo.com.png";
import conversation from "../../images/conversation.gif";
import camera from "../../images/camera.gif";
import house_with_garden1 from "../../images/house-with-garden2_svgrepo.com.png";
import rectangle_green from "../../images/Rectangle 333.jpg";
import rectangle_blue from "../../images/Rectangle b.jpg";

const Procedures = ({ closeModal }) => {
  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{
          display: "block",
          background: "rgba(0, 0, 0, 0.5)",
        }}
        aria-labelledby="exampleModalLabel"
        aria-hidden="false"
      >
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="verify-modal-content " style={{ width: "1214px" }}>
            <button
              type="button"
              className="btn-close-verify"
              onClick={closeModal}
              aria-label="Close"
            >
              <i className="fa fa-times"></i>
            </button>

            <div className="upper-box">
              <div className="header-row">
                <h1 className="title_name">How It Works</h1>
                <button id="call_btn">Have Doubts? - Call Us</button>
              </div>
              <div className="steps">
                <div className="step1">
                  <div className="step_a">
                    <div className="d-flex" style={{ marginBottom: "-9px" }}>
                      <img src={walk} alt="Walk" className="Walk" />
                      <p> We&apos;ll Visit The Property </p>
                    </div>
                    <img
                      src={rectangle_green}
                      alt="Reactangle"
                      className="rectangle_green"
                    />
                  </div>
                  <img
                    src={house_with_garden}
                    alt="House_garden"
                    className="house_garden"
                  />
                </div>

                <div className="step2">
                  <div className="step_b">
                    <div className="d-flex" style={{ marginBottom: "-19px" }}>
                      <p>We&apos;ll Meet You At Location</p>
                      <div>
                        <img
                          src={conversation}
                          alt="Conversation"
                          className="conversation"
                        />
                      </div>
                    </div>
                    <img
                      src={rectangle_blue}
                      alt="Reactangle-B"
                      className="rectangle_blue"
                    />
                  </div>
                </div>

                <div className="step3">
                  <img
                    src={house_with_garden1}
                    alt="House_garden"
                    className="house_garden1"
                  />
                  <div className="step_c">
                    <div className="d-flex" style={{ marginBottom: "-13px" }}>
                      <p> Click Photos & Submit </p>
                      <img src={camera} alt="Camera" className="camera" />
                    </div>
                    <img
                      src={rectangle_green}
                      alt="Reactangle"
                      className="rectangle_green"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Lower Box */}
            <div className="lower-box">
              <h2 className="subtitle">Why Should I Verify My Listings?</h2>
              <ul className="benefits">
                <li className="benefit-item flex items-start">
                  <div className="sign bg-blue-100 text-blue-600 flex items-center justify-center rounded-full w-8 h-8 mr-4">
                    <svg
                      width="12"
                      height="9"
                      viewBox="0 0 12 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.52051 4.32141L4.50739 7.20141L10.4805 1.44141"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <p className="text-gray-700">
                    Your Listings Get A Verified Tag
                  </p>
                </li>
                <li className="benefit-item flex items-start">
                  <div className="sign bg-blue-100 text-blue-600 flex items-center justify-center rounded-full w-8 h-8 mr-4">
                    <svg
                      width="12"
                      height="9"
                      viewBox="0 0 12 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.52051 4.32141L4.50739 7.20141L10.4805 1.44141"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <p className="text-gray-700">
                    Verified Listings Appear At The Top Of Search Results
                  </p>
                </li>
                <li className="benefit-item flex items-start">
                  <div className="sign bg-blue-100 text-blue-600 flex items-center justify-center rounded-full w-8 h-8 mr-4">
                    <svg
                      width="12"
                      height="9"
                      viewBox="0 0 12 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.52051 4.32141L4.50739 7.20141L10.4805 1.44141"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <p className="text-gray-700">
                    Verified Listings Get 3X More Leads
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Procedures;
